import { n as Document } from "../newsdoc-Dtwgg6Im.mjs";
import { ServiceType, stackIntercept } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
//#region src/baboon/service.ts
/**
* @generated from protobuf enum ttab.baboon.FrameType
*/
let FrameType = /* @__PURE__ */ function(FrameType) {
	/**
	* @generated from protobuf enum value: FRAME_UNKNOWN = 0;
	*/
	FrameType[FrameType["FRAME_UNKNOWN"] = 0] = "FRAME_UNKNOWN";
	/**
	* @generated from protobuf enum value: FRAME_TEXT = 1;
	*/
	FrameType[FrameType["FRAME_TEXT"] = 1] = "FRAME_TEXT";
	/**
	* @generated from protobuf enum value: FRAME_IMAGE = 2;
	*/
	FrameType[FrameType["FRAME_IMAGE"] = 2] = "FRAME_IMAGE";
	return FrameType;
}({});
var SetHypenationRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.SetHypenationRequest", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "word",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "hypenated",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "ignore",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.word = "";
		message.hypenated = "";
		message.ignore = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.word = reader.string();
					break;
				case 3:
					message.hypenated = reader.string();
					break;
				case 4:
					message.ignore = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.word !== "") writer.tag(2, WireType.LengthDelimited).string(message.word);
		if (message.hypenated !== "") writer.tag(3, WireType.LengthDelimited).string(message.hypenated);
		if (message.ignore !== false) writer.tag(4, WireType.Varint).bool(message.ignore);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.SetHypenationRequest
*/
const SetHypenationRequest = new SetHypenationRequest$Type();
var SetHypenationResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.SetHypenationResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.SetHypenationResponse
*/
const SetHypenationResponse = new SetHypenationResponse$Type();
var ListHypenationsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListHypenationsRequest", [{
			no: 1,
			name: "language",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "page",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.page = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.page = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.page !== 0n) writer.tag(2, WireType.Varint).int64(message.page);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListHypenationsRequest
*/
const ListHypenationsRequest = new ListHypenationsRequest$Type();
var ListHypenationsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListHypenationsResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => Hypenation
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(Hypenation.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) Hypenation.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListHypenationsResponse
*/
const ListHypenationsResponse = new ListHypenationsResponse$Type();
var Hypenation$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.Hypenation", [
			{
				no: 1,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "word",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "created",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "updated",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "updated_by",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "hypenated",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "ignore",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.word = "";
		message.created = "";
		message.updated = "";
		message.updatedBy = "";
		message.hypenated = "";
		message.ignore = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.word = reader.string();
					break;
				case 3:
					message.created = reader.string();
					break;
				case 4:
					message.updated = reader.string();
					break;
				case 5:
					message.updatedBy = reader.string();
					break;
				case 6:
					message.hypenated = reader.string();
					break;
				case 7:
					message.ignore = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.word !== "") writer.tag(2, WireType.LengthDelimited).string(message.word);
		if (message.created !== "") writer.tag(3, WireType.LengthDelimited).string(message.created);
		if (message.updated !== "") writer.tag(4, WireType.LengthDelimited).string(message.updated);
		if (message.updatedBy !== "") writer.tag(5, WireType.LengthDelimited).string(message.updatedBy);
		if (message.hypenated !== "") writer.tag(6, WireType.LengthDelimited).string(message.hypenated);
		if (message.ignore !== false) writer.tag(7, WireType.Varint).bool(message.ignore);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.Hypenation
*/
const Hypenation = new Hypenation$Type();
var RemoveHypenationRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RemoveHypenationRequest", [{
			no: 1,
			name: "language",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "word",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.language = "";
		message.word = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.language = reader.string();
					break;
				case 2:
					message.word = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.language !== "") writer.tag(1, WireType.LengthDelimited).string(message.language);
		if (message.word !== "") writer.tag(2, WireType.LengthDelimited).string(message.word);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RemoveHypenationRequest
*/
const RemoveHypenationRequest = new RemoveHypenationRequest$Type();
var RemoveHypenationResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RemoveHypenationResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RemoveHypenationResponse
*/
const RemoveHypenationResponse = new RemoveHypenationResponse$Type();
var GetRenderedArticlesRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetRenderedArticlesRequest", [{
			no: 1,
			name: "after",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.after = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.after = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.after !== 0n) writer.tag(1, WireType.Varint).int64(message.after);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetRenderedArticlesRequest
*/
const GetRenderedArticlesRequest = new GetRenderedArticlesRequest$Type();
var GetRenderedArticlesResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetRenderedArticlesResponse", [{
			no: 1,
			name: "events",
			kind: "message",
			repeat: 2,
			T: () => RenderEvent
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.events = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.events.push(RenderEvent.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.events.length; i++) RenderEvent.internalBinaryWrite(message.events[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetRenderedArticlesResponse
*/
const GetRenderedArticlesResponse = new GetRenderedArticlesResponse$Type();
var RenderEvent$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RenderEvent", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "article",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "error",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "rendered",
				kind: "message",
				repeat: 2,
				T: () => RenderedArticle
			},
			{
				no: 6,
				name: "removed",
				kind: "message",
				repeat: 2,
				T: () => RenderedArticle
			},
			{
				no: 7,
				name: "article_version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 8,
				name: "time",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.type = "";
		message.article = "";
		message.error = "";
		message.rendered = [];
		message.removed = [];
		message.articleVersion = 0n;
		message.time = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.article = reader.string();
					break;
				case 4:
					message.error = reader.string();
					break;
				case 5:
					message.rendered.push(RenderedArticle.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 6:
					message.removed.push(RenderedArticle.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 7:
					message.articleVersion = reader.int64().toBigInt();
					break;
				case 8:
					message.time = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.article !== "") writer.tag(3, WireType.LengthDelimited).string(message.article);
		if (message.error !== "") writer.tag(4, WireType.LengthDelimited).string(message.error);
		for (let i = 0; i < message.rendered.length; i++) RenderedArticle.internalBinaryWrite(message.rendered[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.removed.length; i++) RenderedArticle.internalBinaryWrite(message.removed[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		if (message.articleVersion !== 0n) writer.tag(7, WireType.Varint).int64(message.articleVersion);
		if (message.time !== "") writer.tag(8, WireType.LengthDelimited).string(message.time);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RenderEvent
*/
const RenderEvent = new RenderEvent$Type();
var RenderedArticle$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RenderedArticle", [
			{
				no: 1,
				name: "date",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "product",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "layout",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "position",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "pdf",
				kind: "message",
				T: () => RenderedAsset
			},
			{
				no: 6,
				name: "tagged_text",
				kind: "message",
				T: () => RenderedAsset
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.date = "";
		message.product = "";
		message.layout = "";
		message.position = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.date = reader.string();
					break;
				case 2:
					message.product = reader.string();
					break;
				case 3:
					message.layout = reader.string();
					break;
				case 4:
					message.position = reader.string();
					break;
				case 5:
					message.pdf = RenderedAsset.internalBinaryRead(reader, reader.uint32(), options, message.pdf);
					break;
				case 6:
					message.taggedText = RenderedAsset.internalBinaryRead(reader, reader.uint32(), options, message.taggedText);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.date !== "") writer.tag(1, WireType.LengthDelimited).string(message.date);
		if (message.product !== "") writer.tag(2, WireType.LengthDelimited).string(message.product);
		if (message.layout !== "") writer.tag(3, WireType.LengthDelimited).string(message.layout);
		if (message.position !== "") writer.tag(4, WireType.LengthDelimited).string(message.position);
		if (message.pdf) RenderedAsset.internalBinaryWrite(message.pdf, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		if (message.taggedText) RenderedAsset.internalBinaryWrite(message.taggedText, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RenderedArticle
*/
const RenderedArticle = new RenderedArticle$Type();
var RenderedAsset$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RenderedAsset", [
			{
				no: 5,
				name: "download_link",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "size",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 7,
				name: "sha256_hash",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.downloadLink = "";
		message.size = 0n;
		message.sha256Hash = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 5:
					message.downloadLink = reader.string();
					break;
				case 6:
					message.size = reader.int64().toBigInt();
					break;
				case 7:
					message.sha256Hash = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.downloadLink !== "") writer.tag(5, WireType.LengthDelimited).string(message.downloadLink);
		if (message.size !== 0n) writer.tag(6, WireType.Varint).int64(message.size);
		if (message.sha256Hash !== "") writer.tag(7, WireType.LengthDelimited).string(message.sha256Hash);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RenderedAsset
*/
const RenderedAsset = new RenderedAsset$Type();
var CreateFlowRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.CreateFlowRequest", [
			{
				no: 1,
				name: "flow_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "date",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "articles",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 4,
				name: "template_uuid",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.flowUuid = "";
		message.date = "";
		message.articles = [];
		message.templateUuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.flowUuid = reader.string();
					break;
				case 2:
					message.date = reader.string();
					break;
				case 3:
					message.articles.push(reader.string());
					break;
				case 4:
					message.templateUuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.flowUuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.flowUuid);
		if (message.date !== "") writer.tag(2, WireType.LengthDelimited).string(message.date);
		for (let i = 0; i < message.articles.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.articles[i]);
		if (message.templateUuid !== "") writer.tag(4, WireType.LengthDelimited).string(message.templateUuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.CreateFlowRequest
*/
const CreateFlowRequest = new CreateFlowRequest$Type();
var CreateFlowResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.CreateFlowResponse", [{
			no: 1,
			name: "articles",
			kind: "message",
			repeat: 2,
			T: () => PrintArticleReference
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.articles = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.articles.push(PrintArticleReference.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.articles.length; i++) PrintArticleReference.internalBinaryWrite(message.articles[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.CreateFlowResponse
*/
const CreateFlowResponse = new CreateFlowResponse$Type();
var PrintArticleReference$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.PrintArticleReference", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.PrintArticleReference
*/
const PrintArticleReference = new PrintArticleReference$Type();
var CopyArticleToFlowRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.CopyArticleToFlowRequest", [
			{
				no: 1,
				name: "source_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "flow_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "date",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "article",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "source_version",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.sourceUuid = "";
		message.flowUuid = "";
		message.date = "";
		message.article = "";
		message.sourceVersion = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.sourceUuid = reader.string();
					break;
				case 2:
					message.flowUuid = reader.string();
					break;
				case 3:
					message.date = reader.string();
					break;
				case 4:
					message.article = reader.string();
					break;
				case 5:
					message.sourceVersion = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.sourceUuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.sourceUuid);
		if (message.flowUuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.flowUuid);
		if (message.date !== "") writer.tag(3, WireType.LengthDelimited).string(message.date);
		if (message.article !== "") writer.tag(4, WireType.LengthDelimited).string(message.article);
		if (message.sourceVersion !== 0n) writer.tag(5, WireType.Varint).int64(message.sourceVersion);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.CopyArticleToFlowRequest
*/
const CopyArticleToFlowRequest = new CopyArticleToFlowRequest$Type();
var CopyArticleToFlowResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.CopyArticleToFlowResponse", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.CopyArticleToFlowResponse
*/
const CopyArticleToFlowResponse = new CopyArticleToFlowResponse$Type();
var GetScribusInfoRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetScribusInfoRequest", [{
			no: 1,
			name: "uuid",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetScribusInfoRequest
*/
const GetScribusInfoRequest = new GetScribusInfoRequest$Type();
var GetScribusInfoResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetScribusInfoResponse", [
			{
				no: 1,
				name: "fonts",
				kind: "message",
				repeat: 2,
				T: () => ScribusDependency
			},
			{
				no: 2,
				name: "icc_profiles",
				kind: "message",
				repeat: 2,
				T: () => ScribusDependency
			},
			{
				no: 3,
				name: "slots",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 4,
				name: "layers",
				kind: "message",
				repeat: 2,
				T: () => ScribusLayer
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fonts = [];
		message.iccProfiles = [];
		message.slots = [];
		message.layers = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fonts.push(ScribusDependency.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.iccProfiles.push(ScribusDependency.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.slots.push(reader.string());
					break;
				case 4:
					message.layers.push(ScribusLayer.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.fonts.length; i++) ScribusDependency.internalBinaryWrite(message.fonts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.iccProfiles.length; i++) ScribusDependency.internalBinaryWrite(message.iccProfiles[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.slots.length; i++) writer.tag(3, WireType.LengthDelimited).string(message.slots[i]);
		for (let i = 0; i < message.layers.length; i++) ScribusLayer.internalBinaryWrite(message.layers[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetScribusInfoResponse
*/
const GetScribusInfoResponse = new GetScribusInfoResponse$Type();
var ScribusLayer$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ScribusLayer", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "slot",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "frames",
				kind: "message",
				repeat: 2,
				T: () => ScribusFrame
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.name = "";
		message.slot = "";
		message.frames = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.name = reader.string();
					break;
				case 3:
					message.slot = reader.string();
					break;
				case 4:
					message.frames.push(ScribusFrame.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
		if (message.slot !== "") writer.tag(3, WireType.LengthDelimited).string(message.slot);
		for (let i = 0; i < message.frames.length; i++) ScribusFrame.internalBinaryWrite(message.frames[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ScribusLayer
*/
const ScribusLayer = new ScribusLayer$Type();
var ScribusFrame$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ScribusFrame", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "slot",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "type",
				kind: "enum",
				T: () => ["ttab.baboon.FrameType", FrameType]
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.slot = "";
		message.type = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.slot = reader.string();
					break;
				case 3:
					message.type = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.slot !== "") writer.tag(2, WireType.LengthDelimited).string(message.slot);
		if (message.type !== 0) writer.tag(3, WireType.Varint).int32(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ScribusFrame
*/
const ScribusFrame = new ScribusFrame$Type();
var ScribusDependency$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ScribusDependency", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "satisfied",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.satisfied = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.satisfied = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.satisfied !== false) writer.tag(2, WireType.Varint).bool(message.satisfied);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ScribusDependency
*/
const ScribusDependency = new ScribusDependency$Type();
var StoreFontRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.StoreFontRequest", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "filename",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "file",
				kind: "scalar",
				T: 12
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.description = "";
		message.filename = "";
		message.file = /* @__PURE__ */ new Uint8Array(0);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.description = reader.string();
					break;
				case 3:
					message.filename = reader.string();
					break;
				case 4:
					message.file = reader.bytes();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.description !== "") writer.tag(2, WireType.LengthDelimited).string(message.description);
		if (message.filename !== "") writer.tag(3, WireType.LengthDelimited).string(message.filename);
		if (message.file.length) writer.tag(4, WireType.LengthDelimited).bytes(message.file);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.StoreFontRequest
*/
const StoreFontRequest = new StoreFontRequest$Type();
var StoreFontResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.StoreFontResponse", [{
			no: 1,
			name: "version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== "") writer.tag(1, WireType.LengthDelimited).string(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.StoreFontResponse
*/
const StoreFontResponse = new StoreFontResponse$Type();
var GetFontsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetFontsRequest", [{
			no: 1,
			name: "fonts",
			kind: "message",
			repeat: 2,
			T: () => FontRef
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fonts = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fonts.push(FontRef.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.fonts.length; i++) FontRef.internalBinaryWrite(message.fonts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetFontsRequest
*/
const GetFontsRequest = new GetFontsRequest$Type();
var FontRef$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.FontRef", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "if_not_version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.ifNotVersion = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.ifNotVersion = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.ifNotVersion !== "") writer.tag(2, WireType.LengthDelimited).string(message.ifNotVersion);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.FontRef
*/
const FontRef = new FontRef$Type();
var GetFontsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetFontsResponse", [{
			no: 1,
			name: "fonts",
			kind: "message",
			repeat: 2,
			T: () => Font
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fonts = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fonts.push(Font.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.fonts.length; i++) Font.internalBinaryWrite(message.fonts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetFontsResponse
*/
const GetFontsResponse = new GetFontsResponse$Type();
var Font$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.Font", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "file",
				kind: "scalar",
				T: 12
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		message.description = "";
		message.file = /* @__PURE__ */ new Uint8Array(0);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 3:
					message.version = reader.string();
					break;
				case 4:
					message.description = reader.string();
					break;
				case 5:
					message.file = reader.bytes();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(3, WireType.LengthDelimited).string(message.version);
		if (message.description !== "") writer.tag(4, WireType.LengthDelimited).string(message.description);
		if (message.file.length) writer.tag(5, WireType.LengthDelimited).bytes(message.file);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.Font
*/
const Font = new Font$Type();
var ListFontsRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListFontsRequest", [{
			no: 1,
			name: "page",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.page = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.page = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.page !== 0n) writer.tag(1, WireType.Varint).int64(message.page);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListFontsRequest
*/
const ListFontsRequest = new ListFontsRequest$Type();
var ListFontsResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListFontsResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => FontInfo
		}, {
			no: 2,
			name: "next_page",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		message.nextPage = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(FontInfo.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.nextPage = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) FontInfo.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.nextPage !== 0n) writer.tag(2, WireType.Varint).int64(message.nextPage);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListFontsResponse
*/
const ListFontsResponse = new ListFontsResponse$Type();
var FontInfo$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.FontInfo", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "description",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		message.description = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				case 3:
					message.description = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		if (message.description !== "") writer.tag(3, WireType.LengthDelimited).string(message.description);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.FontInfo
*/
const FontInfo = new FontInfo$Type();
var DeleteFontRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.DeleteFontRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.DeleteFontRequest
*/
const DeleteFontRequest = new DeleteFontRequest$Type();
var DeleteFontResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.DeleteFontResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.DeleteFontResponse
*/
const DeleteFontResponse = new DeleteFontResponse$Type();
var StoreICCProfileRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.StoreICCProfileRequest", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "description",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "file",
				kind: "scalar",
				T: 12
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.description = "";
		message.file = /* @__PURE__ */ new Uint8Array(0);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.description = reader.string();
					break;
				case 3:
					message.file = reader.bytes();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.description !== "") writer.tag(2, WireType.LengthDelimited).string(message.description);
		if (message.file.length) writer.tag(3, WireType.LengthDelimited).bytes(message.file);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.StoreICCProfileRequest
*/
const StoreICCProfileRequest = new StoreICCProfileRequest$Type();
var StoreICCProfileResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.StoreICCProfileResponse", [{
			no: 1,
			name: "version",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.version = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.version = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.version !== "") writer.tag(1, WireType.LengthDelimited).string(message.version);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.StoreICCProfileResponse
*/
const StoreICCProfileResponse = new StoreICCProfileResponse$Type();
var ListICCProfilesRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListICCProfilesRequest", [{
			no: 1,
			name: "page",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.page = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.page = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.page !== 0n) writer.tag(1, WireType.Varint).int64(message.page);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListICCProfilesRequest
*/
const ListICCProfilesRequest = new ListICCProfilesRequest$Type();
var ListICCProfilesResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ListICCProfilesResponse", [{
			no: 1,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => ICCProfileInfo
		}, {
			no: 2,
			name: "next_page",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		message.nextPage = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.items.push(ICCProfileInfo.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.nextPage = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.items.length; i++) ICCProfileInfo.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.nextPage !== 0n) writer.tag(2, WireType.Varint).int64(message.nextPage);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ListICCProfilesResponse
*/
const ListICCProfilesResponse = new ListICCProfilesResponse$Type();
var ICCProfileInfo$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.ICCProfileInfo", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "description",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.version = "";
		message.description = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.version = reader.string();
					break;
				case 3:
					message.description = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.version !== "") writer.tag(2, WireType.LengthDelimited).string(message.version);
		if (message.description !== "") writer.tag(3, WireType.LengthDelimited).string(message.description);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.ICCProfileInfo
*/
const ICCProfileInfo = new ICCProfileInfo$Type();
var RenderArticleRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RenderArticleRequest", [
			{
				no: 1,
				name: "article_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "layout_id",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "render_pdf",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "render_png",
				kind: "scalar",
				T: 8
			},
			{
				no: 5,
				name: "png_scale",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.articleUuid = "";
		message.layoutId = "";
		message.renderPdf = false;
		message.renderPng = false;
		message.pngScale = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.articleUuid = reader.string();
					break;
				case 2:
					message.layoutId = reader.string();
					break;
				case 3:
					message.renderPdf = reader.bool();
					break;
				case 4:
					message.renderPng = reader.bool();
					break;
				case 5:
					message.pngScale = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.articleUuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.articleUuid);
		if (message.layoutId !== "") writer.tag(2, WireType.LengthDelimited).string(message.layoutId);
		if (message.renderPdf !== false) writer.tag(3, WireType.Varint).bool(message.renderPdf);
		if (message.renderPng !== false) writer.tag(4, WireType.Varint).bool(message.renderPng);
		if (message.pngScale !== 0n) writer.tag(5, WireType.Varint).int64(message.pngScale);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RenderArticleRequest
*/
const RenderArticleRequest = new RenderArticleRequest$Type();
var RenderArticleResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.RenderArticleResponse", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "pdf_url",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "png_url",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "scribus_url",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "png_width",
				kind: "scalar",
				T: 5
			},
			{
				no: 6,
				name: "png_height",
				kind: "scalar",
				T: 5
			},
			{
				no: 7,
				name: "images",
				kind: "message",
				repeat: 2,
				T: () => MountedImage
			},
			{
				no: 8,
				name: "overflows",
				kind: "message",
				repeat: 2,
				T: () => Overflow
			},
			{
				no: 9,
				name: "tagged_text_url",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "underflows",
				kind: "message",
				repeat: 2,
				T: () => Underflow
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.pdfUrl = "";
		message.pngUrl = "";
		message.scribusUrl = "";
		message.pngWidth = 0;
		message.pngHeight = 0;
		message.images = [];
		message.overflows = [];
		message.taggedTextUrl = "";
		message.underflows = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.pdfUrl = reader.string();
					break;
				case 3:
					message.pngUrl = reader.string();
					break;
				case 4:
					message.scribusUrl = reader.string();
					break;
				case 5:
					message.pngWidth = reader.int32();
					break;
				case 6:
					message.pngHeight = reader.int32();
					break;
				case 7:
					message.images.push(MountedImage.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 8:
					message.overflows.push(Overflow.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 9:
					message.taggedTextUrl = reader.string();
					break;
				case 10:
					message.underflows.push(Underflow.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.pdfUrl !== "") writer.tag(2, WireType.LengthDelimited).string(message.pdfUrl);
		if (message.pngUrl !== "") writer.tag(3, WireType.LengthDelimited).string(message.pngUrl);
		if (message.scribusUrl !== "") writer.tag(4, WireType.LengthDelimited).string(message.scribusUrl);
		if (message.pngWidth !== 0) writer.tag(5, WireType.Varint).int32(message.pngWidth);
		if (message.pngHeight !== 0) writer.tag(6, WireType.Varint).int32(message.pngHeight);
		for (let i = 0; i < message.images.length; i++) MountedImage.internalBinaryWrite(message.images[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.overflows.length; i++) Overflow.internalBinaryWrite(message.overflows[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
		if (message.taggedTextUrl !== "") writer.tag(9, WireType.LengthDelimited).string(message.taggedTextUrl);
		for (let i = 0; i < message.underflows.length; i++) Underflow.internalBinaryWrite(message.underflows[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.RenderArticleResponse
*/
const RenderArticleResponse = new RenderArticleResponse$Type();
var MountedImage$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.MountedImage", [
			{
				no: 1,
				name: "frame",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "bounding_box",
				kind: "message",
				T: () => Rect
			},
			{
				no: 3,
				name: "ppi",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.frame = "";
		message.ppi = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.frame = reader.string();
					break;
				case 2:
					message.boundingBox = Rect.internalBinaryRead(reader, reader.uint32(), options, message.boundingBox);
					break;
				case 3:
					message.ppi = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.frame !== "") writer.tag(1, WireType.LengthDelimited).string(message.frame);
		if (message.boundingBox) Rect.internalBinaryWrite(message.boundingBox, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.ppi !== 0) writer.tag(3, WireType.Bit64).double(message.ppi);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.MountedImage
*/
const MountedImage = new MountedImage$Type();
var Overflow$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.Overflow", [{
			no: 1,
			name: "frame",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "bounding_box",
			kind: "message",
			T: () => Rect
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.frame = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.frame = reader.string();
					break;
				case 2:
					message.boundingBox = Rect.internalBinaryRead(reader, reader.uint32(), options, message.boundingBox);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.frame !== "") writer.tag(1, WireType.LengthDelimited).string(message.frame);
		if (message.boundingBox) Rect.internalBinaryWrite(message.boundingBox, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.Overflow
*/
const Overflow = new Overflow$Type();
var Underflow$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.Underflow", [{
			no: 1,
			name: "frame",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "bounding_box",
			kind: "message",
			T: () => Rect
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.frame = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.frame = reader.string();
					break;
				case 2:
					message.boundingBox = Rect.internalBinaryRead(reader, reader.uint32(), options, message.boundingBox);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.frame !== "") writer.tag(1, WireType.LengthDelimited).string(message.frame);
		if (message.boundingBox) Rect.internalBinaryWrite(message.boundingBox, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.Underflow
*/
const Underflow = new Underflow$Type();
var Rect$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.Rect", [
			{
				no: 1,
				name: "x",
				kind: "scalar",
				T: 1
			},
			{
				no: 2,
				name: "y",
				kind: "scalar",
				T: 1
			},
			{
				no: 3,
				name: "width",
				kind: "scalar",
				T: 1
			},
			{
				no: 4,
				name: "height",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.x = 0;
		message.y = 0;
		message.width = 0;
		message.height = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.x = reader.double();
					break;
				case 2:
					message.y = reader.double();
					break;
				case 3:
					message.width = reader.double();
					break;
				case 4:
					message.height = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.x !== 0) writer.tag(1, WireType.Bit64).double(message.x);
		if (message.y !== 0) writer.tag(2, WireType.Bit64).double(message.y);
		if (message.width !== 0) writer.tag(3, WireType.Bit64).double(message.width);
		if (message.height !== 0) writer.tag(4, WireType.Bit64).double(message.height);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.Rect
*/
const Rect = new Rect$Type();
var GetEditableArchiveRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetEditableArchiveRequest", [{
			no: 1,
			name: "render_id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.renderId = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.renderId = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.renderId !== 0n) writer.tag(1, WireType.Varint).int64(message.renderId);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetEditableArchiveRequest
*/
const GetEditableArchiveRequest = new GetEditableArchiveRequest$Type();
var GetEditableArchiveResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.GetEditableArchiveResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.GetEditableArchiveResponse
*/
const GetEditableArchiveResponse = new GetEditableArchiveResponse$Type();
var LayoutPreviewRequest$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.LayoutPreviewRequest", [
			{
				no: 1,
				name: "sla_file",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "layout",
				kind: "message",
				T: () => Document
			},
			{
				no: 3,
				name: "content_uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "content",
				kind: "message",
				T: () => Document
			},
			{
				no: 5,
				name: "article_layout",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "features",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 8
				}
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.slaFile = "";
		message.contentUuid = "";
		message.articleLayout = "";
		message.features = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.slaFile = reader.string();
					break;
				case 2:
					message.layout = Document.internalBinaryRead(reader, reader.uint32(), options, message.layout);
					break;
				case 3:
					message.contentUuid = reader.string();
					break;
				case 4:
					message.content = Document.internalBinaryRead(reader, reader.uint32(), options, message.content);
					break;
				case 5:
					message.articleLayout = reader.string();
					break;
				case 6:
					this.binaryReadMap6(message.features, reader, options);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap6(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.bool();
					break;
				default: throw new globalThis.Error("unknown map entry field for ttab.baboon.LayoutPreviewRequest.features");
			}
		}
		map[key ?? ""] = val ?? false;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.slaFile !== "") writer.tag(1, WireType.LengthDelimited).string(message.slaFile);
		if (message.layout) Document.internalBinaryWrite(message.layout, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.contentUuid !== "") writer.tag(3, WireType.LengthDelimited).string(message.contentUuid);
		if (message.content) Document.internalBinaryWrite(message.content, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.articleLayout !== "") writer.tag(5, WireType.LengthDelimited).string(message.articleLayout);
		for (let k of globalThis.Object.keys(message.features)) writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.features[k]).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.LayoutPreviewRequest
*/
const LayoutPreviewRequest = new LayoutPreviewRequest$Type();
var LayoutPreviewResponse$Type = class extends MessageType {
	constructor() {
		super("ttab.baboon.LayoutPreviewResponse", [
			{
				no: 1,
				name: "pdf_data",
				kind: "scalar",
				T: 12
			},
			{
				no: 2,
				name: "images",
				kind: "message",
				repeat: 2,
				T: () => MountedImage
			},
			{
				no: 3,
				name: "overflows",
				kind: "message",
				repeat: 2,
				T: () => Overflow
			},
			{
				no: 4,
				name: "scribus_doc",
				kind: "scalar",
				T: 12
			},
			{
				no: 5,
				name: "underflows",
				kind: "message",
				repeat: 2,
				T: () => Underflow
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.pdfData = /* @__PURE__ */ new Uint8Array(0);
		message.images = [];
		message.overflows = [];
		message.scribusDoc = /* @__PURE__ */ new Uint8Array(0);
		message.underflows = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.pdfData = reader.bytes();
					break;
				case 2:
					message.images.push(MountedImage.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.overflows.push(Overflow.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 4:
					message.scribusDoc = reader.bytes();
					break;
				case 5:
					message.underflows.push(Underflow.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.pdfData.length) writer.tag(1, WireType.LengthDelimited).bytes(message.pdfData);
		for (let i = 0; i < message.images.length; i++) MountedImage.internalBinaryWrite(message.images[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.overflows.length; i++) Overflow.internalBinaryWrite(message.overflows[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.scribusDoc.length) writer.tag(4, WireType.LengthDelimited).bytes(message.scribusDoc);
		for (let i = 0; i < message.underflows.length; i++) Underflow.internalBinaryWrite(message.underflows[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message ttab.baboon.LayoutPreviewResponse
*/
const LayoutPreviewResponse = new LayoutPreviewResponse$Type();
/**
* @generated ServiceType for protobuf service ttab.baboon.Assets
*/
const Assets = new ServiceType("ttab.baboon.Assets", [
	{
		name: "StoreFont",
		options: {},
		I: StoreFontRequest,
		O: StoreFontResponse
	},
	{
		name: "GetFonts",
		options: {},
		I: GetFontsRequest,
		O: GetFontsResponse
	},
	{
		name: "ListFonts",
		options: {},
		I: ListFontsRequest,
		O: ListFontsResponse
	},
	{
		name: "DeleteFont",
		options: {},
		I: DeleteFontRequest,
		O: DeleteFontResponse
	},
	{
		name: "StoreICCProfile",
		options: {},
		I: StoreICCProfileRequest,
		O: StoreICCProfileResponse
	},
	{
		name: "ListICCProfiles",
		options: {},
		I: ListICCProfilesRequest,
		O: ListICCProfilesResponse
	}
]);
/**
* @generated ServiceType for protobuf service ttab.baboon.Print
*/
const Print = new ServiceType("ttab.baboon.Print", [
	{
		name: "RenderArticle",
		options: {},
		I: RenderArticleRequest,
		O: RenderArticleResponse
	},
	{
		name: "GetEditableArchive",
		options: {},
		I: GetEditableArchiveRequest,
		O: GetEditableArchiveResponse
	},
	{
		name: "LayoutPreview",
		options: {},
		I: LayoutPreviewRequest,
		O: LayoutPreviewResponse
	},
	{
		name: "CreateFlow",
		options: {},
		I: CreateFlowRequest,
		O: CreateFlowResponse
	},
	{
		name: "CopyArticleToFlow",
		options: {},
		I: CopyArticleToFlowRequest,
		O: CopyArticleToFlowResponse
	},
	{
		name: "GetScribusInfo",
		options: {},
		I: GetScribusInfoRequest,
		O: GetScribusInfoResponse
	},
	{
		name: "GetRenderedArticles",
		options: {},
		I: GetRenderedArticlesRequest,
		O: GetRenderedArticlesResponse
	},
	{
		name: "SetHypenation",
		options: {},
		I: SetHypenationRequest,
		O: SetHypenationResponse
	},
	{
		name: "ListHypenations",
		options: {},
		I: ListHypenationsRequest,
		O: ListHypenationsResponse
	},
	{
		name: "RemoveHypenation",
		options: {},
		I: RemoveHypenationRequest,
		O: RemoveHypenationResponse
	}
]);
//#endregion
//#region src/baboon/service.client.ts
/**
* @generated from protobuf service ttab.baboon.Assets
*/
var AssetsClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Assets.typeName;
		this.methods = Assets.methods;
		this.options = Assets.options;
	}
	/**
	* @generated from protobuf rpc: StoreFont
	*/
	storeFont(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: GetFonts
	*/
	getFonts(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: ListFonts
	*/
	listFonts(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: DeleteFont
	*/
	deleteFont(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: StoreICCProfile
	*/
	storeICCProfile(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: ListICCProfiles
	*/
	listICCProfiles(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service ttab.baboon.Print
*/
var PrintClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Print.typeName;
		this.methods = Print.methods;
		this.options = Print.options;
	}
	/**
	* @generated from protobuf rpc: RenderArticle
	*/
	renderArticle(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: GetEditableArchive
	*/
	getEditableArchive(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* LayoutPreview is used by the CLI tool to do preview rendering.
	*
	* @generated from protobuf rpc: LayoutPreview
	*/
	layoutPreview(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: CreateFlow
	*/
	createFlow(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: CopyArticleToFlow
	*/
	copyArticleToFlow(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: GetScribusInfo
	*/
	getScribusInfo(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetRenderedArticles allows a client to consume and download all finished renders.
	*
	* @generated from protobuf rpc: GetRenderedArticles
	*/
	getRenderedArticles(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetHypenation allows clients to set custom hypenation for a word.
	*
	* @generated from protobuf rpc: SetHypenation
	*/
	setHypenation(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListHypenations is used to list words in the hypenation dictionary.
	*
	* @generated from protobuf rpc: ListHypenations
	*/
	listHypenations(input, options) {
		const method = this.methods[8], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* RemoveHypenation is used to remove a custom hypenation for a word.
	*
	* @generated from protobuf rpc: RemoveHypenation
	*/
	removeHypenation(input, options) {
		const method = this.methods[9], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
//#endregion
export { Assets, AssetsClient, CopyArticleToFlowRequest, CopyArticleToFlowResponse, CreateFlowRequest, CreateFlowResponse, DeleteFontRequest, DeleteFontResponse, Font, FontInfo, FontRef, FrameType, GetEditableArchiveRequest, GetEditableArchiveResponse, GetFontsRequest, GetFontsResponse, GetRenderedArticlesRequest, GetRenderedArticlesResponse, GetScribusInfoRequest, GetScribusInfoResponse, Hypenation, ICCProfileInfo, LayoutPreviewRequest, LayoutPreviewResponse, ListFontsRequest, ListFontsResponse, ListHypenationsRequest, ListHypenationsResponse, ListICCProfilesRequest, ListICCProfilesResponse, MountedImage, Overflow, Print, PrintArticleReference, PrintClient, Rect, RemoveHypenationRequest, RemoveHypenationResponse, RenderArticleRequest, RenderArticleResponse, RenderEvent, RenderedArticle, RenderedAsset, ScribusDependency, ScribusFrame, ScribusLayer, SetHypenationRequest, SetHypenationResponse, StoreFontRequest, StoreFontResponse, StoreICCProfileRequest, StoreICCProfileResponse, Underflow };
